//选择人员组件
import Vue from "vue";
import SelectionBox from "./personnel";
SelectionBox.newInstance = properties => {
  const _props = properties || {};
  const Instance = new Vue({
    data: Object.assign({}, _props,{
      staffCheckedId: [],
      positionCheckedId: [],
      departmentCheckedId: [],
      roleCheckedId: []
    }),
    render(createElement) {
      return createElement(SelectionBox, {
        props: Object.assign({}, _props, {
          staffCheckedId: this.staffCheckedId,
          positionCheckedId: this.positionCheckedId,
          departmentCheckedId: this.departmentCheckedId,
          roleCheckedId: this.roleCheckedId
        }),
        on: {
          "on-ok": this.ok,
          onCancel: this.cancel
        }
      });
    },
    methods: {
      ok(checkedData) {
        // if (this.closing) return;
        // if (this.loading) {
        //   this.buttonLoading = true;
        // } else {
          this.$children[0].visible = false;
        // console.log(this.$children[0]);
        this.remove();
        // }
        this.onOk(checkedData);
        // this.remove();
      },
      cancel() {
        // console.log("弹框关闭");
        this.$children[0].visible = false;
        this.onCancel();
        this.remove();
      },
      destroy() {
        this.$destroy();
        document.body.removeChild(this.$el);
        this.onRemove();
      },
      remove() {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      onOk() {},
      onCancel() {},
      onRemove() {}
    }
  });
  const component = Instance.$mount();
  document.body.appendChild(component.$el);
  const personnel = Instance.$children[0];
  return {
    show(props) {
      // if ("multiple" in props) {
      //   personnel.$parent.multiple = props.multiple;
      // }
      // console.log(personnel.$parent);
      if ("onCancel" in props) {
        personnel.$parent.onCancel = props.onCancel;
      }
      if ("staffCheckedId" in props) {
        props.staffCheckedId.forEach(item => {
          personnel.$parent.staffCheckedId.push(item);
        });
      }
      if ("positionCheckedId" in props) {
        props.positionCheckedId.forEach(item => {
          personnel.$parent.positionCheckedId.push(item);
        });
      }
      if ("departmentCheckedId" in props) {
        props.departmentCheckedId.forEach(item => {
          personnel.$parent.departmentCheckedId.push(item);
        });
      }
      if ("roleCheckedId" in props) {
        props.roleCheckedId.forEach(item => {
          personnel.$parent.roleCheckedId.push(item);
        });
      }
      if ("onOk" in props) {
        personnel.$parent.onOk = props.onOk;
      }
      //销毁实例
      personnel.$parent.onRemove = props.onRemove;
      personnel.visible = true;
    }
  };
};

let selectionBoxInstance;
function getSelectionBoxInstance(props) {
  selectionBoxInstance =
    selectionBoxInstance ||
    SelectionBox.newInstance({
      tabs: props.tabs,
      multiple: props.multiple
    });
  return selectionBoxInstance;
}

function personnel(props) {
  let instance = getSelectionBoxInstance(props);
  props.onRemove = function() {
    selectionBoxInstance = null;
  };
  instance.show(props);
}

export default {
  staff(props = {}) {
    //选择员工
    props.tabs = ["staff"];
    personnel(props);
  },
  position(props = {}) {
    //选择职务
    props.tabs = ["position"];
    personnel(props);
  },
  department(props = {}) {
    //选择部门
    props.tabs = ["department"];
    personnel(props);
  },
  role(props = {}) {
    //选择角色
    props.tabs = ["role"];
    personnel(props);
  },
  custom(props = {}) {
    //自定义选项
    personnel(props);
  }
};
